import React from "react";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { TipTabStyled, TipTabsStyled } from "../tips.styled";

type TipTab = "tips" | "credit" | "monthly";

interface TipTabsProps {
  activeTab: TipTab;
  setActiveTab: (tab: TipTab) => void;
}

export const TipTabs: React.FC<TipTabsProps> = (props) => {
  const { t } = useTranslation();

  return (
    <TipTabsStyled style={{ justifyContent: "center", userSelect: "none" }}>
      <TipTabStyled
        active={props.activeTab === "tips"}
        onClick={() => props.setActiveTab("tips")}
      >
        <Text
          fontSize={FontSize.Large}
          fontFamily={
            props.activeTab === "tips"
              ? FontFamily.MontserratSemiBold
              : FontFamily.MontserratRegular
          }
        >
          {t("CompanyTip.Tip")}
        </Text>
      </TipTabStyled>

      <TipTabStyled
        active={props.activeTab === "credit"}
        onClick={() => props.setActiveTab("credit")}
      >
        <Text
          fontSize={FontSize.Large}
          fontFamily={
            props.activeTab === "credit"
              ? FontFamily.MontserratSemiBold
              : FontFamily.MontserratRegular
          }
        >
          {t("TipCredit.Transactions")}
        </Text>
      </TipTabStyled>
      <TipTabStyled
        active={props.activeTab === "monthly"}
        onClick={() => props.setActiveTab("monthly")}
      >
        <Text
          fontSize={FontSize.Large}
          fontFamily={
            props.activeTab === "monthly"
              ? FontFamily.MontserratSemiBold
              : FontFamily.MontserratRegular
          }
        >
          {t("MonthlyTipReport.MonthlyReports")}
        </Text>
      </TipTabStyled>
    </TipTabsStyled>
  );
};
